import React from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default class ContainerToast extends React.Component {

    render() {
        return (<ToastContainer />)
    }
}